import { render, staticRenderFns } from "./PageShippingAddress.vue?vue&type=template&id=64e7de4a"
import script from "./PageShippingAddress.vue?vue&type=script&lang=js"
export * from "./PageShippingAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports